import { Component } from '@angular/core';
import { QuickLeadIntakeFormState } from '../../models/enums/quick-lead-intake-form-state.enum';

@Component({
  selector: 'quick-lead-intake-host',
  templateUrl: './quick-lead-intake-host.component.html',
  styleUrls: ['./quick-lead-intake-host.component.scss'],
  standalone: false
})
export class QuickLeadIntakeHostComponent {
  currentFormState!: QuickLeadIntakeFormState;
  quickLeadIntakeFormState = QuickLeadIntakeFormState;
}
